import script from "./OfferGoldSoftCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferGoldSoftCard.vue?vue&type=script&setup=true&lang=js"

import "./OfferGoldSoftCard.vue?vue&type=style&index=0&id=31530eca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31530eca"]])

export default __exports__